<template>
  <div class="participant-preview min-w-0 rounded-xl border border-gray-200 bg-white overflow-hidden">
    <div class="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-4 py-3">
      <div>
        <div class="text-xs font-semibold uppercase tracking-wider text-gray-500">Participant preview</div>
        <div class="mt-0.5 text-sm font-medium text-gray-900">{{ ceremonyLabel }}</div>
      </div>
      <span class="rounded-full bg-blue-100 px-2.5 py-1 text-xs font-semibold text-blue-800">Exact form</span>
    </div>
    <div class="relative min-h-96 bg-white px-3 pb-5 pt-2 sm:px-5">
      <RegistrationForm
        :key="previewKey"
        :events="events"
        :additional-fields-input="fields"
        :name="previewName"
        :email="previewEmail"
        :event="ceremonyId"
        :organiser-slug="organiserSlug"
        :force-step="2"
        :hide-event="true"
        :survey-title="title"
        :survey-description="description"
        :submitting="disableSubmission"
        @submit="handleSubmit"
      />
      <div
        v-if="previewMessage"
        class="mx-auto mt-4 max-w-lg rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800"
        role="status"
      >
        {{ previewMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import RegistrationForm from '../Registration/RegistrationForm.vue'

export default {
  name: 'SurveyParticipantPreview',
  components: { RegistrationForm },
  props: {
    fields: { type: Array, required: true },
    ceremonyId: { type: String, default: '' },
    ceremonyLabel: { type: String, default: 'Choose a ceremony to test conditions' },
    organiserSlug: { type: String, default: 'preview' },
    previewKey: { type: String, required: true },
    events: { type: Array, default: () => [] },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    previewMessage: { type: String, default: '' },
    disableSubmission: { type: Boolean, default: false },
  },
  data() {
    return {
      previewName: 'Alex Morgan',
      previewEmail: 'alex.morgan@example.com',
    }
  },
  methods: {
    handleSubmit(payload) {
      this.$emit('preview-submit', payload)
    },
  },
}
</script>

<style scoped>
.participant-preview {
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.08);
}
</style>
